import React, { useRef } from "react";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { InputAdornment } from "@mui/material";

function ShareLink({ link }: { link: string }) {
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const textareaRef = useRef();

  const selectAll = (event: React.FocusEvent | React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();

    if (event.target instanceof Element) {
      const eventElement = event.target as Element;
      if (eventElement.nodeName !== "INPUT") return;
    } else return;
    const textarea = event.target as HTMLTextAreaElement;

    if (textarea.value !== "") {
      textarea.focus();
      textarea.select();
      navigator.clipboard.writeText(textarea.value);
      setOpenSnackbar(true);
    }
  };

  const copyLink = (event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();

    if (textareaRef && textareaRef.current) {
      const textarea = textareaRef.current as HTMLTextAreaElement;
      if (textarea.value !== "") {
        textarea.focus();
        textarea.select();
        navigator.clipboard.writeText(textarea.value);
        setOpenSnackbar(true);
      }
    }
  };

  const handleClose = () => {
    setOpenSnackbar(false);
  };

  return (
    <Box sx={{ width: { xs: 300, md: 400 } }}>
      <FormControl fullWidth>
        <TextField
          slotProps={{
            htmlInput: {
              readOnly: true,
            },
            inputLabel: { shrink: true },
            input: {
              endAdornment: (
                <InputAdornment
                  sx={{ alignSelf: "baseline", mt: 1.5 }}
                  position="end"
                >
                  <IconButton
                    color="inherit"
                    aria-label="Copy Link"
                    onClick={copyLink}
                  >
                    <ContentCopyIcon />
                  </IconButton>
                </InputAdornment>
              ),
            },
          }}
          inputRef={textareaRef}
          onMouseDown={selectAll}
          value={link}
          id="outlined-basic"
          label="Link"
          variant="outlined"
        />
      </FormControl>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={openSnackbar}
        autoHideDuration={1000}
        onClose={handleClose}
        message=""
      >
        <Alert
          onClose={handleClose}
          severity="success"
          variant="filled"
          sx={{ width: "100%" }}
        >
          Link Copied!
        </Alert>
      </Snackbar>
    </Box>
  );
}

export default ShareLink;
